import React, { useEffect } from 'react';

// Get the main platform URL based on environment
const getMainPlatformUrl = () => {
  if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
    return 'http://localhost:3000';
  }
  return 'https://ai.app.platform.halisoft.biz';
};

/**
 * Login - Redirects to the main platform's unified login page
 * The main platform handles authentication and redirects back with token
 */
const Login = () => {
  const mainPlatformUrl = getMainPlatformUrl();

  useEffect(() => {
    // Get the return URL (where to redirect after login)
    const urlParams = new URLSearchParams(window.location.search);
    const redirect = urlParams.get('redirect') || '/dashboard';

    // Build the customer portal return URL
    const returnUrl = `${window.location.origin}${redirect}`;

    // Redirect to main platform login with HaliLab branding
    // The main platform will redirect back after successful login
    const loginUrl = `${mainPlatformUrl}/halilab/login?returnUrl=${encodeURIComponent(returnUrl)}`;

    window.location.href = loginUrl;
  }, [mainPlatformUrl]);

  // Show loading while redirecting
  return (
    <div style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #0a1628 0%, #0f2847 40%, #0a1628 100%)',
      color: 'white',
      fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, sans-serif'
    }}>
      <div style={{ textAlign: 'center' }}>
        <div style={{ fontSize: '24px', marginBottom: '16px' }}>
          Hali<span style={{ color: '#8b5cf6' }}>Lab</span>
        </div>
        <div style={{ color: 'rgba(255,255,255,0.6)' }}>
          Redirecting to login...
        </div>
      </div>
    </div>
  );
};

export default Login;
